/* eslint-disable */
export default function tabs() {
  document.querySelectorAll('.tabset').forEach((tabset) => {
    const $tabset = jQuery(tabset);

    $tabset.tabset({
      tabLinks: '.tab-link',
      attr: 'href',
      addToParent: false,
      event: 'click',
      onInit: (api) => {
        const activeTab = api.getActiveTab();
        const curTabLink = api.$tabLinks.filter((index, tabLink) => tabLink.getAttribute(api.options.attr) === `#${activeTab.attr('id')}`);

        if (curTabLink.length) {
          curTabLink[0].setAttribute('aria-selected', 'true');
        }
      },
      onBeforeChange: (api, prevTab) => {
        const prevTabLink = api.$tabLinks.filter((index, tabLink) => tabLink.getAttribute(api.options.attr) === `#${prevTab.attr('id')}`);

        if (prevTabLink.length) {
          prevTabLink[0].setAttribute('aria-selected', 'false');
        }
      },
      onChange: (api) => {
        const activeTab = api.getActiveTab();
        const curTabLink = api.$tabLinks.filter((index, tabLink) => tabLink.getAttribute(api.options.attr) === `#${activeTab.attr('id')}`);

        if (curTabLink.length) {
          curTabLink[0].setAttribute('aria-selected', 'true');
        }
      },
    });
  });
}

// jQuery Tabs plugin
;(function($, $win) {
  'use strict';

  function Tabset($holder, options) {
    this.$holder = $holder;
    this.options = options;
    this.resizeTimer = null;

    this.init();
  }

  Tabset.prototype = {
    init: function() {
      this.$tabLinks = this.$holder.find(this.options.tabLinks);

      this.setStartActiveIndex();
      this.setActiveTab();

      if (this.options.autoHeight) {
        this.$tabHolder = $(this.$tabLinks.eq(0).attr(this.options.attr)).parent();
      }

      this.makeCallback('onInit', this);
    },

    setStartActiveIndex: function() {
      const $classTargets = this.getClassTarget(this.$tabLinks);
      let $activeLink = $classTargets.filter('.' + this.options.activeClass);
      let activeIndex;

      activeIndex = $classTargets.index($activeLink);

      this.activeTabIndex = this.prevTabIndex = (activeIndex === -1 ? (this.options.defaultTab ? 0 : null) : activeIndex);
    },

    setActiveTab: function() {
      this.$tabLinks.each((i, link) => {
        const $link = $(link);
        const $classTarget = this.getClassTarget($link);
        const $tab = $($link.attr(this.options.attr));

        if (i !== this.activeTabIndex) {
          $classTarget.removeClass(this.options.activeClass);
          $tab.addClass(this.options.tabHiddenClass).removeClass(this.options.activeClass);
        } else {
          $classTarget.addClass(this.options.activeClass);
          $tab.removeClass(this.options.tabHiddenClass).addClass(this.options.activeClass);
        }

        this.attachTabLink($link, i);
      });
    },

    attachTabLink: function($link, i) {
      if (this.options.event === 'mouseenter') {
        $link.on('keydown' + '.tabset', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();

            if (this.activeTabIndex === this.prevTabIndex && this.activeTabIndex !== i) {
              this.activeTabIndex = i;
              this.switchTabs();
            }
          }
        });
      }

      $link.on(this.options.event + '.tabset', (e) => {
        e.preventDefault();

        if (this.activeTabIndex === this.prevTabIndex && this.activeTabIndex !== i) {
          this.activeTabIndex = i;
          this.switchTabs();
        }
      });
    },

    resizeHolder: function(height) {
      if (height) {
        clearTimeout(this.resizeTimer);

        this.$tabHolder.css({'height': height +'px'});
        this.resizeTimer = setTimeout(() => {
          this.$tabHolder.css({'height': ''});
        }, this.options.animSpeed);
      } else {
        this.$tabHolder.css({'height': ''});
      }
    },

    switchTabs: function() {
      const $prevLink = this.$tabLinks.eq(this.prevTabIndex);
      const $nextLink = this.$tabLinks.eq(this.activeTabIndex);

      const $prevTab = this.getTab($prevLink);
      const $nextTab = this.getTab($nextLink);

      this.makeCallback('onBeforeChange', this, $prevTab);

      $prevTab.removeClass(this.options.activeClass);

      if (this.haveTabHolder()) {
        this.resizeHolder($prevTab.outerHeight());
      }

      this.getClassTarget($prevLink).removeClass(this.options.activeClass);

      $prevTab.addClass(this.options.tabHiddenClass);
      $nextTab.removeClass(this.options.tabHiddenClass).addClass(this.options.activeClass);

      this.getClassTarget($nextLink).addClass(this.options.activeClass);

      if (this.haveTabHolder()) {
        this.resizeHolder($nextTab.outerHeight());

        this.prevTabIndex = this.activeTabIndex;
        this.makeCallback('onChange', this);
      } else {
        this.prevTabIndex = this.activeTabIndex;
      }
    },

    getClassTarget: function($link) {
      return this.options.addToParent ? $link.parent() : $link;
    },

    getActiveTab: function() {
      return this.getTab(this.$tabLinks.eq(this.activeTabIndex));
    },

    getTab: function($link) {
      return $($link.attr(this.options.attr));
    },

    haveTabHolder: function() {
      return this.$tabHolder && this.$tabHolder.length;
    },

    destroy: function() {
      this.$tabLinks.off('.tabset').each((i, link) => {
        const $link = $(link);

        this.getClassTarget($link).removeClass(this.options.activeClass);
        $($link.attr(this.options.attr)).removeClass(this.options.activeClass + ' ' + this.options.tabHiddenClass);
      });

      this.$holder.removeData('Tabset');
    },

    makeCallback: function(name) {
      if (typeof this.options[name] === 'function') {
        const args = Array.prototype.slice.call(arguments);
        args.shift();
        this.options[name].apply(this, args);
      }
    }
  };

  $.fn.tabset = function(opt) {
    const args = Array.prototype.slice.call(arguments);
    const method = args[0];

    const options = $.extend({
      activeClass: 'active',
      addToParent: true,
      autoHeight: false,
      defaultTab: true,
      animSpeed: 500,
      tabLinks: 'a',
      attr: 'href',
      event: 'click',
      tabHiddenClass: 'js-tab-hidden'
    }, opt);

    return this.each(function() {
      const $holder = jQuery(this);
      const instance = $holder.data('Tabset');

      if (typeof opt === 'object' || typeof opt === 'undefined') {
        $holder.data('Tabset', new Tabset($holder, options));
      } else if (typeof method === 'string' && instance) {
        if (typeof instance[method] === 'function') {
          args.shift();
          instance[method].apply(instance, args);
        }
      }
    });
  };
}(jQuery, jQuery(window)));
